import { Routes } from '@angular/router';
import { adminGuard, authGuard, blockOperatorGuard, operatorGuard, redirectIfAuthenticatedGuard } from './core/auth/auth.guard';
import { ShellComponent } from './shared/components/shell/shell.component';

export const routes: Routes = [
  {
    path: 'auth',
    loadComponent: () =>
      import('./features/auth/auth.component').then(m => m.AuthComponent),
    canActivate: [redirectIfAuthenticatedGuard],
  },
  {
    path: '',
    component: ShellComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'regulate',
        pathMatch: 'full',
      },
      {
        path: 'regulate',
        canActivate: [blockOperatorGuard],
        loadComponent: () =>
          import('./features/horizon-scanning/horizon-scanning.component').then(m => m.HorizonScanningComponent),
      },
      {
        path: 'personalisation',
        canActivate: [blockOperatorGuard],
        loadComponent: () =>
          import('./features/personalisation/personalisation.component').then(m => m.PersonalisationComponent),
      },
      {
        path: 'settings',
        canActivate: [adminGuard, blockOperatorGuard],
        loadComponent: () =>
          import('./features/settings/settings.component').then(m => m.SettingsComponent),
      },
      {
        path: 'internal/admin',
        canActivate: [operatorGuard],
        loadComponent: () =>
          import('./features/internal/admin/admin.component').then(m => m.AdminComponent),
      },
      {
        path: 'tenants',
        canActivate: [operatorGuard],
        loadComponent: () =>
          import('./features/tenants/tenants.component').then(m => m.TenantsComponent),
      },
    ],
  },
  {
    path: 'accept-invite',
    loadComponent: () =>
      import('./features/accept-invite/accept-invite.component').then(m => m.AcceptInviteComponent),
  },
  {
    path: '**',
    loadComponent: () =>
      import('./features/not-found/not-found.component').then(m => m.NotFoundComponent),
  },
];
